import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { SnackbarProvider, useSnackbar } from 'notistack';

function App() {
  
  const [file,setFile]=useState(null);
  const [loading, setLoading]=useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const upload=async ()=>{
    if(!file){
     // alert("invalid");
      enqueueSnackbar("Please Select A file first",{variant: 'warning'})
      return;
    }
    const formData=new FormData();
    formData.append('file',file);
    
    setLoading(true);
    await axios.post("https://final-major.onrender.com",formData,{
      headers: {
        "Content-Type":"multipart/form-data",
      }
    }).then((res)=>{
      setLoading(false);
      console.log(res);
      if(res.data==="Malware"){
        enqueueSnackbar("Malware",{variant: 'error'});
      }
      else{
        enqueueSnackbar("Benign",{variant: 'success'});
      }
    })
    .catch((err)=>{
      setLoading(false);
    });
  }
  return (
    <div className="App">
      <div className='container'>
        <input type='file' onChange={(e)=>setFile(e.target.files[0])}/>
        <button onClick={upload}>
          {loading? <CircularProgress size="15px" style={{color: "white"}}/>:"Upload"}
        </button>
      </div>
    </div>
  );
}

export default App;
